import { useQuery } from '@tanstack/react-query';
import getStudioList from 'Api/schedule-ruleset/getStudioList';
import getStudioListResponse from './model/response/getStudioListResponse';

const useGetStudio = ({ enabled }) => {
  return useQuery({
    queryKey: ['ruleset-studio-list'],
    queryFn: async () => {
      const response = await getStudioList();

      const result = getStudioListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetStudio;
